import restaurantInstance from '../instance'

const fetchTableTimerConfigs = () => {
	return restaurantInstance.get('/tableTimerConfigs')
}

export default fetchTableTimerConfigs
